"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PostAssetsResponse = exports.PostAssetsRequest = exports.AssetUploadTypes = void 0;
const typebox_1 = require("@sinclair/typebox");
// Shadowing enum from MediaConvert sdk, rather than
// adding additional dependencies here.
const LanguageCode = [
    'AAR',
    'ABK',
    'AFR',
    'AKA',
    'AMH',
    'ARA',
    'ARG',
    'ASM',
    'AVA',
    'AVE',
    'AYM',
    'AZE',
    'BAK',
    'BAM',
    'BEL',
    'BEN',
    'BIH',
    'BIS',
    'BOD',
    'BOS',
    'BRE',
    'BUL',
    'CAT',
    'CES',
    'CHA',
    'CHE',
    'CHU',
    'CHV',
    'COR',
    'COS',
    'CRE',
    'CYM',
    'DAN',
    'DEU',
    'DIV',
    'DZO',
    'ELL',
    'ENG',
    'ENM',
    'EPO',
    'EST',
    'EUS',
    'EWE',
    'FAO',
    'FAS',
    'FIJ',
    'FIN',
    'FRA',
    'FRM',
    'FRY',
    'FUL',
    'GER',
    'GLA',
    'GLE',
    'GLG',
    'GLV',
    'GRN',
    'GUJ',
    'HAT',
    'HAU',
    'HEB',
    'HER',
    'HIN',
    'HMO',
    'HRV',
    'HUN',
    'HYE',
    'IBO',
    'IDO',
    'III',
    'IKU',
    'ILE',
    'INA',
    'IND',
    'IPK',
    'ISL',
    'ITA',
    'JAV',
    'JPN',
    'KAL',
    'KAN',
    'KAS',
    'KAT',
    'KAU',
    'KAZ',
    'KHM',
    'KIK',
    'KIN',
    'KIR',
    'KOM',
    'KON',
    'KOR',
    'KUA',
    'KUR',
    'LAO',
    'LAT',
    'LAV',
    'LIM',
    'LIN',
    'LIT',
    'LTZ',
    'LUB',
    'LUG',
    'MAH',
    'MAL',
    'MAR',
    'MKD',
    'MLG',
    'MLT',
    'MON',
    'MRI',
    'MSA',
    'MYA',
    'NAU',
    'NAV',
    'NBL',
    'NDE',
    'NDO',
    'NEP',
    'NLD',
    'NNO',
    'NOB',
    'NOR',
    'NYA',
    'OCI',
    'OJI',
    'ORI',
    'ORJ',
    'ORM',
    'OSS',
    'PAN',
    'PLI',
    'POL',
    'POR',
    'PUS',
    'QAA',
    'QPC',
    'QUE',
    'ROH',
    'RON',
    'RUN',
    'RUS',
    'SAG',
    'SAN',
    'SIN',
    'SLK',
    'SLV',
    'SME',
    'SMO',
    'SNA',
    'SND',
    'SOM',
    'SOT',
    'SPA',
    'SQI',
    'SRB',
    'SRD',
    'SRP',
    'SSW',
    'SUN',
    'SWA',
    'SWE',
    'TAH',
    'TAM',
    'TAT',
    'TEL',
    'TGK',
    'TGL',
    'THA',
    'TIR',
    'TNG',
    'TON',
    'TSN',
    'TSO',
    'TUK',
    'TUR',
    'TWI',
    'UIG',
    'UKR',
    'URD',
    'UZB',
    'VEN',
    'VIE',
    'VOL',
    'WLN',
    'WOL',
    'XHO',
    'YID',
    'YOR',
    'ZHA',
    'ZHO',
    'ZUL',
];
const LanguageCodes = typebox_1.Type.Union(LanguageCode.map((code) => typebox_1.Type.Literal(code)));
const AssetSupplementTypes = typebox_1.Type.Union([
    typebox_1.Type.Literal('audio-config'),
    typebox_1.Type.Literal('caption-config'),
]);
const AssetPrimaryTypes = typebox_1.Type.Union([
    typebox_1.Type.Literal('audio'),
    typebox_1.Type.Literal('image'),
    typebox_1.Type.Literal('stream'),
    typebox_1.Type.Literal('stream-watermark'),
    typebox_1.Type.Literal('video'),
]);
exports.AssetUploadTypes = typebox_1.Type.Union([
    AssetPrimaryTypes,
    AssetSupplementTypes,
]);
const AssetSupplementRequest = typebox_1.Type.Object({
    assetId: typebox_1.Type.String(),
    description: typebox_1.Type.Optional(typebox_1.Type.String()),
    fileName: typebox_1.Type.String(),
    language: typebox_1.Type.String(),
    prefix: typebox_1.Type.String(),
    slug: LanguageCodes,
    type: AssetSupplementTypes,
});
const AssetPrimaryRequest = typebox_1.Type.Object({
    fileName: typebox_1.Type.String(),
    prefix: typebox_1.Type.String(),
    type: AssetPrimaryTypes,
    fileType: typebox_1.Type.String(),
    fileSize: typebox_1.Type.Number(),
    duration: typebox_1.Type.Optional(typebox_1.Type.Union([typebox_1.Type.Number(), typebox_1.Type.Null()])),
    width: typebox_1.Type.Optional(typebox_1.Type.Union([typebox_1.Type.Number(), typebox_1.Type.Null()])),
    height: typebox_1.Type.Optional(typebox_1.Type.Union([typebox_1.Type.Number(), typebox_1.Type.Null()])),
});
exports.PostAssetsRequest = typebox_1.Type.Union([
    AssetPrimaryRequest,
    AssetSupplementRequest,
]);
const AssetResponse = typebox_1.Type.Object({
    assetId: typebox_1.Type.String(),
    url: typebox_1.Type.String({ format: 'uri' }),
});
const AudioConfigResponse = typebox_1.Type.Object({
    audioConfigId: typebox_1.Type.String(),
    url: typebox_1.Type.String({ format: 'uri' }),
});
const CaptionConfigResponse = typebox_1.Type.Object({
    captionConfigId: typebox_1.Type.String(),
    url: typebox_1.Type.String({ format: 'uri' }),
});
const ErrorResponse = typebox_1.Type.String();
exports.PostAssetsResponse = typebox_1.Type.Union([
    AssetResponse,
    AudioConfigResponse,
    CaptionConfigResponse,
    ErrorResponse,
]);
